export const QUERY_PARAMETERS = {
    NEXT_URL: "nextUrl"
};